import styled, { css } from 'styled-components';

const Th = styled.th`
  border-bottom: 1px solid var(--color-border-default);
  margin: 0;
  padding: 0 16px;
`;

const Td = styled.td`
  border-bottom: 1px solid var(--color-border-default);
  margin: 0;
  padding: 2px 16px;
`;

const Tr = styled.tr`
  transition: all 0.1s ease-in-out;
  height: 48px;
  background: var(--color-bg-body);

  ${Td}:first-child, ${Th}:first-child {
    padding-right: 0;
  }

  ${({ selected, error, disabled }) => {
    return (
      (selected || error || disabled) &&
      css`
        background-color: ${error ? 'var(--color-error-weakest)' : 'var(--color-bg-weaker)'};
      `
    );
  }}

  :hover {
    background-color: var(--color-bg-weakest);
  }

  button {
    p:hover {
      color: var(--color-accent-primary-default); //WTF
    }
  }
`;

const HeaderSortable = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  font-size: 12px;
  font-weight: 800;
  gap: 12px;
  justify-content: space-between;
  min-height: 48px;

  ${({ sortable }) =>
    sortable &&
    css`
      cursor: pointer;
    `}
`;

const TableSortArrow = styled.span`
  position: relative;
  top: 2px;
  width: 24px;
`;

const Tbody = styled.tbody`
  font-size: 14px;
`;

const LoaderWrapper = styled.div`
  background: var(--color-bg-weakest);
  border-radius: var(--size-border-radius-md);
  height: 24px;
  margin: 10px 0;
  opacity: 0.9;
  width: 100%;
`;

const Thead = styled.thead`
  background-color: var(--color-bg-weaker);
  color: var(--color-fg-weakest);
  position: relative;
  text-align: left;
  text-transform: uppercase;
`;

export { HeaderSortable, LoaderWrapper, TableSortArrow, Tbody, Td, Th, Thead, Tr };
